import { Injectable } from '@angular/core';
/**
 * Async modal dialog service
 * DialogService makes this app easier to test by faking this service.
 * TODO: better modal implementation that doesn't use window.confirm
 */
@Injectable()
export class DialogService {
  /**
   * Ask user to confirm an action. `message` explains the action and choices.
   * Returns promise resolving to `true`=confirm or `false`=cancel
  */
  confirm(message?: string, parm?: string) {
    const prompt = `${message ?? ''}${parm ?? ''}` || 'Is it OK?';
    return new Promise<boolean>(resolve => {        
      return resolve(window.confirm(prompt));
    });
  };
}
